;
(function ($, window, document, undefined) {
    'use strict';

    var capone = function (el, options) {
        this.options = options;
        this.els = options.els;

        if (this.els.$body.hasClass('NotifyModeratorPage')) {
            this.fixTextarea();
            this.reportMessage();
        }
    };

    capone.prototype = {

        fixTextarea: function () {
            $('#lia-additionalInformation').attr('placeholder', $('.lia-form-validation-help-text').detach().text());
        },

        reportMessage: function () {
            // buttons container
            var $group = $('.lia-form-submit.lia-button-group');

            // clone submit button
            var $submit = $('.lia-button-Submit-action').hide();
            var $fake = $submit.clone();
            $submit.after($fake.show());

            // listening click on fake button
            $fake.click(function (e) {
                e.preventDefault();

                // getting the extra information
                var message = $('#lia-additionalInformation').val();

                // faking the loading
                $group.children().addClass('lia-link-disabled');

                // hitting the api
                $.getJSON('http://lithium.software.eu.playstation.com/capone.php', {
                    id_message: location.href.split('message-uid/')[1],
                    id_reporter: LITHIUM.CommunityJsonObject.User.id,
                    extra: message
                }, function (response) {
                    $fake.prev().click();
                });
            });
        }

    };

    $.fn.capone = function (options) {
        var args     = Array.prototype.slice.call(arguments, 1),
            $item    = $(this),
            instance = $item.data('capone');

        if (!instance) {
            instance = new capone(this, options);
            $item.data('capone', instance);
        }

        if (typeof options === 'string') {
            instance[options].apply(instance, args);
        }

        return this;
    };

}) (jQuery, window, document);
